import { FC } from 'react';

interface CopyLink24Props {
  fill?: string;
}

const CopyLink24: FC<CopyLink24Props> = ({ fill = "#909090" }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.00039 8.61914H8.40039V4.21914C8.40039 3.34005 9.1213 2.61914 10.0004 2.61914H20.0004C20.4247 2.61914 20.8317 2.78771 21.1318 3.08777C21.4318 3.38783 21.6004 3.79479 21.6004 4.21914V14.2191C21.6004 14.6435 21.4318 15.0505 21.1318 15.3505C20.8317 15.6506 20.4247 15.8191 20.0004 15.8191H15.6004V20.2191C15.6004 20.6435 15.4318 21.0505 15.1318 21.3505C14.8317 21.6506 14.4247 21.8191 14.0004 21.8191H4.00039C3.57604 21.8191 3.16908 21.6506 2.86902 21.3505C2.56896 21.0505 2.40039 20.6435 2.40039 20.2191V10.2191C2.40039 9.34005 3.1213 8.61914 4.00039 8.61914ZM9.60039 3.81914V8.61914H14.0004C14.4247 8.61914 14.8317 8.78771 15.1318 9.08777C15.4318 9.38783 15.6004 9.79479 15.6004 10.2191V14.6191H20.4004V3.81914H9.60039ZM14.4004 9.81914H3.60039V20.6191H14.4004V9.81914Z" fill={fill}/>
    </svg>
  );
}

export default CopyLink24;
import { FC } from 'react';

interface CopyLink24Props {
  fill?: string;
}

const CopyLink24: FC<CopyLink24Props> = ({ fill = "#909090" }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.00039 8.61914H8.40039V4.21914C8.40039 3.34005 9.1213 2.61914 10.0004 2.61914H20.0004C20.4247 2.61914 20.8317 2.78771 21.1318 3.08777C21.4318 3.38783 21.6004 3.79479 21.6004 4.21914V14.2191C21.6004 14.6435 21.4318 15.0505 21.1318 15.3505C20.8317 15.6506 20.4247 15.8191 20.0004 15.8191H15.6004V20.2191C15.6004 20.6435 15.4318 21.0505 15.1318 21.3505C14.8317 21.6506 14.4247 21.8191 14.0004 21.8191H4.00039C3.57604 21.8191 3.16908 21.6506 2.86902 21.3505C2.56896 21.0505 2.40039 20.6435 2.40039 20.2191V10.2191C2.40039 9.34005 3.1213 8.61914 4.00039 8.61914ZM9.60039 3.81914V8.61914H14.0004C14.4247 8.61914 14.8317 8.78771 15.1318 9.08777C15.4318 9.38783 15.6004 9.79479 15.6004 10.2191V14.6191H20.4004V3.81914H9.60039ZM14.4004 9.81914H3.60039V20.6191H14.4004V9.81914Z" fill={fill}/>
    </svg>
  );
}

export default CopyLink24;
